type Props = {
  size?: number;
  className?: string;
};

export function SolIcon({ size = 44, className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-label="SOL"
    >
      <defs>
        <linearGradient id="sol-g" x1="8" y1="24" x2="24" y2="8" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
      </defs>
      <circle fill="#121212" cx="16" cy="16" r="16" />
      {/* Three skewed bars, the outer two pointing one way and the middle the
          other, as in the Solana mark. */}
      <g fill="url(#sol-g)">
        <path d="M10.2 20.9a.6.6 0 01.43-.18h13.1c.27 0 .4.32.21.5l-2.59 2.6a.6.6 0 01-.43.18H7.82a.3.3 0 01-.21-.51l2.59-2.59z" />
        <path d="M10.2 8.18A.62.62 0 0110.63 8h13.1c.27 0 .4.33.21.51l-2.59 2.6a.6.6 0 01-.43.17H7.82a.3.3 0 01-.21-.51l2.59-2.59z" />
        <path d="M21.35 14.5a.6.6 0 00-.43-.18H7.82a.3.3 0 00-.21.51l2.59 2.6c.11.1.27.17.43.17h13.1c.27 0 .4-.32.21-.5l-2.59-2.6z" />
      </g>
    </svg>
  );
}
